import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import * as _moment from 'moment/moment';
import { Router } from '@angular/router';
import { ForgotService } from '../../shared/Forgot.Service';
import { UserId } from 'src/app/shared/userid.model';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { AppInsightsService } from '../../shared/AppInsights.Service';

@Component({
  selector: 'app-client-userid',
  templateUrl: './client-userid.component.html',
  styleUrls: ['./client-userid.component.scss']
})
export class ClientUseridComponent implements OnInit, AfterViewInit, OnDestroy {
  public showPlaceholder: boolean;
  public error: boolean;
  public message: any;
  public resp: any;
  public radioSelected = 'ssn';
  public uid: string;
  public uuid: string;
  public govid = '';
  public showId = false;
  public isLoading = false;
  public pasteData = '';
  public validate = true;
  public isMonth = false;
  public isDay = false;
  public isYear = false;
  public formErrorFields: any = {
    govid: false,
  };
  public type: string = 'password';
  public show = false;
  constructor(private forgotService: ForgotService, private router: Router, private appInsightsService: AppInsightsService) { }

  ssnmask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // 000-00-0000
  maskedInputController;

  @ViewChild('ssn') public ssn: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.ssn.nativeElement,
        mask: this.ssnmask,
        guide : false
      });
    });
  }
  ngOnDestroy() {
    this.maskedInputController.destroy();
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.showPlaceholder = true;
    this.type = 'password';
    this.appInsightsService.logEvent("Forgot UI Page - Client UserId");
  }
  
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }
  
  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }
  
  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }
  
  validateOnKeyPress(model){
    if(model === 'govid'){
      if(!!this.govid && this.govid.replace(/[- ()]/g, '').length === 9){
        this.validateForm('govid');
      }
    }
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formErrorFields.govid || !!this.formErrorFields.govidVal) {
      setError = true;
      setTimeout(() => this.ssn.nativeElement.focus(), 0);
      setTimeout(() => this.ssn.nativeElement.select(), 0);
      window.scrollTo(0,this.ssn.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }

    return setError;
  }

  isErrorPresent() {
    if (!this.formErrorFields.govid && !this.formErrorFields.govidVal) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['govid'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
    	isErrPresent = this.validateForm(fields[j]);
		if (isErrPresent) {
			break;
		}
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validateForm(model) {
    let error = false;
    this.validate = true;
    if (model === 'govid') {
      if (!this.govid) {
        this.formErrorFields.govid = true;
        this.formErrorFields.govidVal = false;
        error = true;
      } else if (this.govid !== '' && this.govid.replace(/[- ()]/g, '').length !== 9) {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = true;
        error = true;
      } else {
        this.formErrorFields.govid = false;
        this.formErrorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

   if (!!this.govid && !this.isErrorPresent() && !error) {
     this.validate = error;
   }
    return error;
  }

  cancel() {
    window.scrollTo(0, 0);
    this.router.navigate(['client']);
  }
  
    paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }
  
  continue() {
   if (!this.validateAllFields()) {
    setTimeout(() => {
      window.scrollTo(0, 0);
      this.error = false;
      this.isLoading = true;
      this.validate = true;
    });
    const user = new UserId();
      if (this.pasteData === this.govid) {
        user.ssnPasteEvent = 'Yes';
      } else {
        user.ssnPasteEvent = 'No';
      }
    user.ssn = this.govid.replace(/[- ()]/g, '');
    user.userType = 'client';
    user.idType = this.radioSelected;
    const bodyString = JSON.stringify(user);
    this.forgotService.getUserId(bodyString).subscribe( res => {
        this.resp = res;
        if (this.resp) {        
          if (this.resp.status_code !== '200') {
            setTimeout(() => {
	            this.isLoading = false;
	        });
            this.message = this.resp.message;
            this.error = true;
            this.validate = false;
            setTimeout(() => {
		      this.maskedInputController = textMask.maskInput({
		        inputElement: this.ssn.nativeElement,
		        mask: this.ssnmask,
		        guide : false
		      });
		    });
          } else {
            this.error = false;
            let url = false;
            let question = false;
            if (this.resp.url && !question) {
              url = true;
              console.log('url ' + this.resp.url);
              window.location.href = window.location.origin + this.resp.url;
            }

            if (this.resp.questions && !url) {
              question = true;
              this.forgotService.setUserType('client');
              this.forgotService.setType('uid');
              this.forgotService.setQuestions(this.resp.questions);
              this.router.navigate(['/questions']);
            }
          }
        }
      });
    } else {
      this.focusOnInput();
    }
  }

  toggleShow() {
    this.show = !this.show;
    this.type = this.show ? 'text' : 'password';
  }

  generateSession() {
    this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
    function(c) {
      const r = window.crypto.getRandomValues(new Uint8Array(1))[0] & 0xf; return (c === 'x' ? r : (r & 0x3 | 0x8 )).toString(16);
    });
    console.log('session: ' + this.uuid);
  }
}
